"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const TableContainer_1 = require("./TableContainer");
const { root, withToolbar } = TableContainer_1.tableContainerClasses;
const MuiTableContainerOverrides = {
    MuiTableContainer: {
        styleOverrides: {
            root: ({ theme }) => ({
                [`&.${root}`]: {
                    border: `1px solid ${theme.palette.gray[300]}`,
                    borderRadius: '1px',
                    maxHeight: '439px',
                    [`&.${withToolbar}`]: {
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                    }
                },
            }),
        },
    },
};
exports.default = MuiTableContainerOverrides;
//# sourceMappingURL=MuiTableContainerOverrides.js.map